<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[6]" :innerTitle="navList[6].navChildList[0].name" :innerLink="navList[6].navChildList[0].toLink"></inner-nav>
      <div class="headquarters-content">
        <div class="headquarters-msg">
          <div class="title">
            <h1>CONTACT</h1>
            <h2>联系总部</h2>
          </div>
          <div class="address-tel">
            <img src="../../../static/img/address.png" alt="">
            <ul>
              <li>
                <span>公司名称：</span>
                <p>{{companyInfo.name}}</p>
              </li>
              <li>
                <span>公司地址：</span>
                <p>{{companyInfo.location}}</p>
              </li>
            </ul>

          </div>

          <div class="address-tel">
            <img src="../../../static/img/tel.png" alt="">
            <ul>
              <li>
                <span>电子邮箱：</span>
                <p>{{companyInfo.email}}</p>
              </li>
              <li>
                <span>联系电话：</span>
                <p>{{companyInfo.phone}}</p>
              </li>
              <li>
                <span>传真号码：</span>
                <p>{{companyInfo.fax}}</p>
              </li>
              <li>
                <span>邮政编码：</span>
                <p>{{companyInfo.postalCode}}</p>
              </li>
            </ul>
          </div>

        </div>
        <div class="headquarters-map">
          <div id="allmap"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        companyInfo:{}
      }
    },
    components: {
      ad,
      InnerNav
    },
    methods:{
      bindMap(){
        var map = new BMap.Map('allmap');// 创建Map实例
//        var point = new BMap.Point(116.418948, 40.010023);//北京市朝阳区大屯路东315号（金泉时代广场）1118室
        var point = new BMap.Point(115.352457, 38.954252);//保定白沟京白路与北一环交叉口西南角

        map.centerAndZoom(point, 16);// 初始化地图,设置中心点坐标和地图级别
        var marker = new BMap.Marker(point);        // 创建标注
        map.addOverlay(marker);
        map.setCurrentCity("保定");// 设置地图显示的城市 此项是必须设置的
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

        //自定义目的地图片
//        var map = new BMap.Map("allmap");
////设置中心点坐标--固定的位置--7号线大郊亭--金海国际
//        var point = new BMap.Point(116.418948,40.010023);
////设置地图级别（1-18）
//        map.centerAndZoom(point,16);
////单独设定图标的样式
//        var icon = new BMap.Icon('http://wx.58haha.cn/1.png', new BMap.Size(20, 32), {
//          anchor: new BMap.Size(10, 30)
//        });
////创建一个图像标注实例。point参数指定了图像标注所在的地理位置
//        var mkr = new BMap.Marker(new BMap.Point(116.418948,40.010023), {
//          icon: icon
//        });
////将覆盖物添加到地图中
//        map.addOverlay(mkr);
////将地图的中心点更改为给定的点
//        map.panTo(116.418948,40.010023);
//      }


      }

    },
    mounted:function(){
      this.bindMap();
    },
    created(){
      this.$http.get(`/outer/companyInfo/getCompanyInfo.do`).then((res)=>{
          this.companyInfo=res.data
      })
    }
  }
</script>

<style scoped lang="less">
  .headquarters-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    clear: both;
    overflow: hidden;
    width:12rem;
      .headquarters-msg{
        width:5rem;
        height:4.2rem;
        float: left;
          .title{
            width:1.26rem;
            border-bottom: 1px solid #F53A37;
            padding-bottom: .2rem;
            font-family:PingFangSC-Medium;
              h1{
                font-size:.4rem;
                font-weight:500;
                color:rgba(238,238,238,1);
                line-height:.4rem;
              }
              h2{
                font-size:.16rem;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:.16rem;
              }
          }
          .address-tel{
            font-family:PingFangSC-Medium;
            clear: both;
            overflow: hidden;
            width:100%;
            padding-top:.2rem;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
              img{
                width:.5rem;
                height:.5rem;
                float: left;
              }
              ul{
                width:4rem;
                float: left;
                padding-left:.1rem;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                overflow: hidden;
                  li {
                    overflow: hidden;
                    clear: both;
                    width:100%;
                      span{
                        font-size:.16rem;
                        font-weight:500;
                        color:#333333;
                        line-height:.3rem;
                        float: left;
                      }
                      p{
                        font-size:.14rem;
                        font-weight:400;
                        color:#333333;
                        line-height:.3rem;
                        float: left;
                        width:2.6rem;
                      }

                  }
              }
          }
      }

      .headquarters-map{
        width:7rem;
        height:4.2rem;
        float: right;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
          #allmap{
            height:100%;
            width:100%;
          }
      }

  }



</style>



// WEBPACK FOOTER //
// src/pages/contact/headquarters.vue